<template>
  <div>
    <!-- 搜索部分 -->
    <div class="table-container">
      <vab-query-form style="margin: 0">
        <el-form ref="form" :model="queryForm" :inline="true" @submit.native.prevent>
          <el-form-item label="订单编号">
            <el-input v-model="queryForm.order_code" placeholder="请输入订单号" clearable style="width: 250px" />
          </el-form-item>
          <el-form-item  label="订单类型">
            <el-select @change="fetchData" clearable  v-model="queryForm.order_type" placeholder="请选择">
                <el-option label="包裹" value="1"></el-option>
                <el-option label="商品" value="2"></el-option>
                <el-option label="代买/代付" value="3"></el-option>
              </el-select>
          </el-form-item>
          <el-form-item  label="邮箱/昵称">
            <el-input v-model="queryForm.user_keywords" placeholder="邮箱/昵称" clearable style="width: 250px" />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" native-type="submit" @click="fetchData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form>
      <el-table ref="tableSort" v-loading="listLoading" :data="list" element-loading-text="加载中" :height="height"
        style="width: 100%" border @selection-change="setSelectRows">
        <el-table-column width="240px" prop="coupon_money" align="center" label="领取用户 - (用户编号)">
          <template #default="{ row }">
              <span>{{row.user.nickname}} - ({{row.user.ydm_code}})</span>
          </template>
        </el-table-column>
        <el-table-column width="120px" prop="coupon_money" align="center" label="类型">
          <template #default="{ row }">
              <span v-if="row.order_type == 1">包裹</span>
              <span v-if="row.order_type == 2">商品</span>
              <span v-if="row.order_type == 3">代买/代付</span>
              <span v-if="row.order_type == 0">-</span>
          </template>
        </el-table-column>
        <el-table-column width="240px" prop="coupon_money" align="center" label="单号">
          <template #default="{ row }">
              {{row.order.code?row.order.code:'-'}}
          </template>
        </el-table-column>
        <el-table-column prop="coupon_name" align="center" label="优惠劵名称"></el-table-column>
        <el-table-column width="120px" prop="coupon_money" align="center" label="优惠劵面值"></el-table-column>
        <el-table-column prop="state_name" align="center" label="使用状态"></el-table-column>
        <el-table-column width="180px" prop="usage_time" align="center" label="使用时间"></el-table-column>
      </el-table>
      <el-pagination :current-page="queryForm.page" :layout="layout" :page-sizes="[20, 40, 60, 100]"
        :page-size="queryForm.limit" :total="total" @current-change="handleCurrentChange"
        @size-change="handleSizeChange"></el-pagination>
    </div>
  </div>
</template>

<script>
  import {
    coupon_select
  } from '@/api/coupon'
  export default {
    components: {

    },
    filters: {},
    data() {
      return {
        listLoading: true,
        list: [],
        queryForm: {
          page: 1,
          limit: 10,
          kor_type: 4,
        },
        total: 0,
        height: '70vh',
        layout: 'total, sizes, prev, pager, next, jumper',
      }
    },
    mounted() {
      this.fetchData()
    },
    methods: {
      fetchData() {
        // 优惠劵列表
        var data = {
          ...this.queryForm,
        }
        this.listLoading = true
        coupon_select(data)
          .then((res) => {
            this.list = res.data.list
            this.listLoading = false
            this.total = res.data.count
          })
          .catch((err) => {
            this.listLoading = false
          })
      },
      handleSizeChange(e) {
        // 分页
        this.queryForm.limit = e
        this.queryForm.page = 1
        this.fetchData()
      },
      handleCurrentChange(e) {
        // 分页
        this.queryForm.page = e
        this.fetchData()
      },
    },
  }
</script>

<style scoped>
  :deep .el-button--mini {
    padding: 5px 11px;
  }

  :deep .right-panel {
    display: flex;
    align-items: center;
  }

  .demo-tabs .custom-tabs-label span {
    vertical-align: super;
    margin-left: 4px;
  }

  ::v-deep(.el-badge__content.is-fixed) {
    top: 11px;
    right: 17px;
  }

  .table-container {
    padding: 15px;
    padding-top: 30px;
    box-sizing: border-box;
    border-left: 1px solid #e4e7ed;
    border-right: 1px solid #e4e7ed;
    border-bottom: 1px solid #e4e7ed;
  }

  .el-tabs__item {
    width: 200px;
    /* 设置宽度为200px */
  }

  .el-badge {
    width: 60px !important;
  }

  ::v-deep(.el-tabs__header) {
    margin: 0 !important;
  }

  ::v-deep(.el-tabs__header span) {
    font-weight: bold;
  }

  .demo-table-expand {
    font-size: 0;
    padding-left: 150px;
    box-sizing: border-box;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 30%;
  }

  .dabaoStyle {
    background: #ffddaa;
    color: #999;
    border: 1px solid #fd5;
  }

  .fahuoStyle {
    background: #99dddd;
    color: #999;
    border: 1px solid 00FFFF;
  }

  .zhuanyunStyle {
    background: #ffffaa;
    color: #999;
    border: 1px solid FFFF00;
  }
</style>
